import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { I18NextPipe } from 'angular-i18next';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { report } from 'src/app/dashboards/models';
import { register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { gridItem, property } from 'src/app/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';
import { ReportsDialogHelpComponent } from '../reports-dialog-help/reports-dialog-help.component';
import { EnvironmentService } from 'src/app/services/services/environmet.service';

@Component({
    selector: 'app-repQDetails-wizard',
    templateUrl: './reports-wizard.component.html',
    styleUrls: ['./reports-wizard.component.scss'],
    standalone: false
})
@register("Reports_wizard")
export class ReportswizardComponent implements OnInit, WidgetBaseComponent {
  @Input() public gridItem: gridItem;
  @Input() public isEdit: boolean;
  @Output() public completed = new EventEmitter<boolean>();

  /*StandAlone */
  @Input() public isStandAlone: boolean;
  @HostBinding('style.min-height') hostMinHeight = '500px';
  @HostBinding('class') classes =EnvironmentService.isOneIdentity? "":"OneIdentityHeight";
  readyToShowReport: boolean = false;
  showReport: boolean = false;
  dataEquality = true;
  viewReport() {
    this.showReport = true;
    this.dataEquality = false;
    setTimeout(() => { this.dataEquality = true; }, 300);

  }
  /*StandAlone end*/

  filter: string = "";
  dataLoaded: boolean = true;

  range = new UntypedFormGroup({ start: new UntypedFormControl(), end: new UntypedFormControl() });
  reports: report[];
  loadedReport: report;
  selectedReport: any = {};
  serviceNumbers: any[] = [];
  sysShowEmpty: boolean;
  sysAgentNoCalls: boolean;
  sysGroupByTime: any[] = [];
  columns: any[] = [];
  relativeFromCompleted: boolean = false;
  relativeToCompleted: boolean = false;
  reportCode: string = "";

  agents$: Observable<any[]>;
  userGroups$: Observable<any[]>;
  queues$: Observable<any[]>;
  terminatingNumbers$: Observable<any[]>;
  menus$: Observable<any[]>;
  accesspoints: any[];

  queueProperties$: Observable<property[]>;
  queueProperties: property[];
  visualTypedisabledItems: number[] = [3];
  sysDimsForFilter: string[] = [];

  public notifier: Subject<void> = new Subject<void>();

  constructor(private DashboardsService: DashboardService, private i18nextPipe: I18NextPipe, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.hostMinHeight = this.isStandAlone ? "calc(100vh - 10px)" : "500px";
    this.getReports();
    setTimeout(() => this.completedNotifier(false), 0);
  }

  getReports() {
    let reportsApi = this.isStandAlone ? this.DashboardsService.getAllReports() : this.DashboardsService.getPccReports();
    reportsApi.pipe(take(1)).subscribe(reports => {
      this.reports = reports;
      if (this.gridItem.setup.reportId != null) {
        let report = reports.find(r => r.id == this.gridItem.setup.reportId);
        this.loadedReport = report;
      }
    });
  }

  filteredReports(type): any[] {
    if (type == "standard") {
      return this.reports?.filter(r => (this.filter.length == 0 || r.shortDescription.toLowerCase().includes(this.filter.toLowerCase())) && r.subReportId == 0) || [];
    }
    if (type == "custom") {
      return this.reports?.filter(r => (this.filter.length == 0 || r.shortDescription.toLowerCase().includes(this.filter.toLowerCase())) && r.subReportId > 0) || [];
    }
    return this.reports?.filter(r => this.filter.length == 0 || r.shortDescription.toLowerCase().includes(this.filter.toLowerCase())) || [];
  }

  showHelp($event, report: report) {
    $event.cancelBubble = true;

    let data = report;
    let position = $event.currentTarget.getBoundingClientRect();
    let left = position.left - 220;
    let top = window.innerHeight > position.top + 410 ? position.top + 30 : position.top - 410;
    this.dialog.open(ReportsDialogHelpComponent, {
      panelClass: 'dialog-help-pannel',
      backdropClass: "backdrop-invisible",
      data,
      width: "440px",
      height: "400px",
      position: { top: `${top}px`, left: `${left}px` },
    });

  }

  onReportSelected(report) {
    if (!report) return;
    this.gridItem.setup = { period: { type: 1, toTime:"24:00" }, sysGroupByTime: ' ' };
    this.gridItem.setup.reportId = report.id;
    this.gridItem.setup.reportSubId = report.subReportId;
    this.gridItem.setup.filters = {};
    this.gridItem.setup["reportCode"] = report.report_Code;
    this.loadedReport = report;
    setTimeout(() => {
      this.notifier.next();
    }, 0);
    this.showReport = false;
  }

  completedNotifier(isCompleted) {
    this.completed.emit(isCompleted);
  }

  refreshNotifier(refresh) {
    this.getReports();
  }
}
